export const STATUS_META = {
  recebido: { label: "Recebido", color: "#64748B", bg: "#64748B15" },
  em_analise: { label: "Em análise", color: "#0EA5E9", bg: "#0EA5E915" },
  documentacao_pendente: { label: "Doc. pendente", color: "#F59E0B", bg: "#F59E0B15" },
  necessita_correcao: { label: "Necessita correção", color: "#F97316", bg: "#F9731615" },
  aguardando_aprovacao: { label: "Aguardando aprovação", color: "#8B5CF6", bg: "#8B5CF615" },
  em_aprovacao: { label: "Em aprovação", color: "#6366F1", bg: "#6366F115" },
  aprovado: { label: "Aprovado", color: "#10B981", bg: "#10B98115" },
  reprovado: { label: "Reprovado", color: "#D62828", bg: "#D6282815" },
  liberado: { label: "Liberado", color: "#14B8A6", bg: "#14B8A615" },
  concluido: { label: "Concluído", color: "#114B5F", bg: "#114B5F15" },
};

export const PROJECT_STATUS_META = {
  em_andamento: { label: "Em andamento", color: "#0EA5E9" },
  aguardando: { label: "Aguardando", color: "#F59E0B" },
  finalizado: { label: "Finalizado", color: "#10B981" },
  cancelado: { label: "Cancelado", color: "#D62828" },
};

export const STAGE_STATUS_META = {
  pendente: { label: "Pendente", color: "#64748B", bg: "#64748B15" },
  em_andamento: { label: "Em andamento", color: "#0EA5E9", bg: "#0EA5E915" },
  concluido: { label: "Concluído", color: "#10B981", bg: "#10B98115" },
};

export function formatDate(dt) {
  if (!dt) return "-";
  try {
    return new Date(dt).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "-"; }
}

export function formatDateTime(dt) {
  if (!dt) return "-";
  try {
    return new Date(dt).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "-"; }
}

export function formatSize(bytes) {
  if (!bytes) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
